import SecondaryHeader from "@3gaam/capp/src/view/components/main/secondaryHeader";

const ExternalLayout = ({ children, title }) => {
  return (
    <>
      <SecondaryHeader title={title} />
      {children}
    </>
  );
};

export default ExternalLayout;
